import styled from 'styled-components';
import { DESKTOP_WIDTH, TABLET_WIDTH, MOBILE_WIDTH } from '../globalUtils';
import { Area, Title, RedStripe } from './index.style';
import Provider0 from '../../icons/provider0.png';
import Provider0X2 from '../../icons/provider0@2x.png';
import Provider0X3 from '../../icons/provider0@3x.png';
import Provider1 from '../../icons/provider1.png';
import Provider1X2 from '../../icons/provider1@2x.png';
import Provider1X3 from '../../icons/provider1@3x.png';
import Provider2 from '../../icons/provider2.png';
import Provider2X2 from '../../icons/provider2@2x.png';
import Provider2X3 from '../../icons/provider2@3x.png';
import Provider3 from '../../icons/provider3.png';
import Provider3X2 from '../../icons/provider3@2x.png';
import Provider3X3 from '../../icons/provider3@3x.png';
import Provider4 from '../../icons/provider4.png';
import Provider4X2 from '../../icons/provider4@2x.png';
import Provider4X3 from '../../icons/provider4@3x.png';
import Provider5 from '../../icons/provider5.png';
import Provider5X2 from '../../icons/provider5@2x.png';
import Provider5X3 from '../../icons/provider5@3x.png';

export const Providers = styled.div`
    display: flex;
    margin-top: 152px;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    img {
        margin: 0 20px 140px;

        @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
            margin: 0 20px 70px;
        }
        @media only screen and (max-width: ${TABLET_WIDTH}px) {
            margin: 0 0 70px;
        }
    }
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        margin-top: 113px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        justivy-content: space-around;
        margin-top: 31px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        margin-top: 21px;
    }
`;

export const Provider0Icon = styled.img.attrs({
    src: Provider0,
    srcSet: `${Provider0X2} 2x, ${Provider0X3} 3x`,
})`
    height: 98px;
    width: 216px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 68px;
        width: 149px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 49px;
        width: 108px;
        order: 2;
    }
`;


export const Provider1Icon = styled.img.attrs({
    src: Provider1,
    srcSet: `${Provider1X2} 2x, ${Provider1X3} 3x`,
})`
    height: 59px;
    width: 296px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 41px;
        width: 205px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 30px;
        width: 148px;
        order: 3;
    }
`;

export const Provider2Icon = styled.img.attrs({
    src: Provider2,
    srcSet: `${Provider2X2} 2x, ${Provider2X3} 3x`,
})`
    height: 65px;
    width: 183px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 45px;
        width: 126px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 33px;
        width: 92px;
        order: 1;
    }
`;

export const Provider3Icon = styled.img.attrs({
    src: Provider3,
    srcSet: `${Provider3X2} 2x, ${Provider3X3} 3x`,
})`
    height: 71px;
    width: 207px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 49px;
        width: 145px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 36px;
        width: 104px;
        order: 4;
    }
`;

export const Provider4Icon = styled.img.attrs({
    src: Provider4,
    srcSet: `${Provider4X2} 2x, ${Provider4X3} 3x`,
})`
    height: 121px;
    width: 63px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 84px;
        width: 44px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 60px;
        width: 31px;
        order: 5;
    }
`;

export const Provider5Icon = styled.img.attrs({
    src: Provider5,
    srcSet: `${Provider5X2} 2x, ${Provider5X3} 3x`,
})`
    height: 154px;
    width: 245px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 107px;
        width: 171px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 77px;
        width: 123px;
        order: 0;
    }
`;

export const CTA = styled.div`
    height: 59px;
    width: 322px;
    background-color: #003a70;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    color: #f1efef;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    font-size: 23px;
    cursor: pointer;
    margin-bottom: 62px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 44px;
        width: 228px;
        background-color: #ff4438;
        border-radius: 4px;
        box-shadow: 0 2px 3px 0px rgba(0, 0, 0, 0.5);
        color: #f1efef;
        font-size: 16px;
    }
`;

export { Area, Title, RedStripe };